import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { BrandButton } from './BrandButton';
export function Hero() {
  return <section id="top" className="relative overflow-hidden border-b border-white/5 bg-ink-900" data-id="element-87" data-mp="9k0ep7vr8fpn">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.06]" style={{
      backgroundImage: 'linear-gradient(to right, #ffffff 1px, transparent 1px), linear-gradient(to bottom, #ffffff 1px, transparent 1px)',
      backgroundSize: '72px 72px'
    }} data-id="element-88" data-mp="4mrt0xbedtjn" />
      <div className="relative mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-28 lg:py-32" data-id="element-89" data-mp="sde1gppbdfu6">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="max-w-3xl" data-id="element-90" data-mp="neawf59c39m7">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-91" data-mp="384jtl03lnltg">
            Viridia Analytics | Real Estate
          </p>
          <h1 className="mt-6 font-display text-4xl font-bold leading-[1.06] tracking-tight text-white sm:text-5xl lg:text-[3.75rem]" data-id="element-92" data-mp="3o7vj9hzbpjw8">
            Every missed call answered live. Every form, text, and DM answered in under 60
            seconds.
          </h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/65 sm:text-lg" data-id="element-93" data-mp="3eb92b4a4bczh">
            You already pay Zillow for the leads. AI voice picks up the calls your team
            cannot get to, 24/7. AI text answers the written leads within the minute. Every
            one qualified, booked on your agents&rsquo; calendars, and logged in your CRM.
          </p>

          <div className="mt-9 flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:gap-6" data-id="element-94" data-mp="2vj7rr4nzdya8">
            <BrandButton label="Book a 15-Minute Missed-Lead Audit" size="lg" withArrow className="w-full sm:w-auto" data-id="element-95" data-mp="2hjymh01bcol1" />
            <Link to="/how-it-works" className="rounded text-sm font-medium text-white/70 underline decoration-white/25 underline-offset-4 transition-colors hover:text-brand hover:decoration-brand focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-96" data-mp="s3mbny4btqw9">
              See how it works
            </Link>
          </div>

          <p className="mt-7 flex max-w-xl items-start gap-2 text-sm leading-relaxed text-white/45" data-id="element-97" data-mp="1b15lh3ylzdjq">
            <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand" aria-hidden="true" data-id="element-98" data-mp="162uf537ivl69" />
            Works with Follow Up Boss, kvCORE, Sierra, and the CRM you already run. Flat
            monthly fee. No per-minute meters.
          </p>
        </motion.div>
      </div>
    </section>;
}